export enum Segments {
  CURRENT = "errors_current",
  HISTORY = "errors_history"
}

export enum Command {
  None = 0,
  Start = 1,
  Stop = 2,
  Pause = 3,
  Restart = 4,
  BoostOn = 5,
  BoostOff = 6,
  Check = 7,
  CheckAll = 8,
  Reset = 9
}

// Расширение функциональности
export namespace Command {
  export function toString(value: Command): string {
    return Command[value] || 'Unknown';
  }

  export function isValid(value: number): value is Command {
    return value in Command;
  }

  export function fromString(str: string): Command | undefined {
    const enumValue = Command[str as keyof typeof Command];
    return typeof enumValue === 'number' ? enumValue : undefined;
  }
}